export default __webpack_public_path__ + "static/media/brake-pads.37024f61.jpg";